import React from 'react';
import {Script, ScriptStrategy} from 'gatsby';

export function Survicate() {
  return (
    <Script
      src='https://survey.survicate.com/workspaces/4352efbad9ef28e8e248a6bd8dec9318/web_surveys.js'
      id='survicate'
      strategy={ScriptStrategy.idle}
      defer={true}
    />
  );
}
